const driverShiftsTemplates = {
  table: {
    headers: {
      name: 'Name',
      shiftStart: 'Shift Start',
      shiftEnd: 'Shift End',
      breakStart: 'Break Start',
      breakEnd: 'Break End',
      breakNumberStart: 'Break {{num}} Start',
      breakNumberEnd: 'Break {{num}} End',
    },
    actions: {
      delete: 'Delete',
    },
    toolTip: {
      noPermission: "You don't have permission to perform this action",
    },
  },
  deleteModal: {
    header: 'Delete',
    body: 'Are you sure you want to delete the shift template/s?',
  },
  deleteToast: {
    body: 'Shift template deleted successfully',
  },
  form: {
    title: 'Shift Template',
    templateNameHeader: 'Template Name',
    displayName: 'Display name',
    templateInfoHeader: 'Template info',
    shiftStart: 'Shift start',
    shiftEnd: 'Shift end',
    breakStart: 'Break start',
    breakEnd: 'Break end',
    addBreak: 'Add break',
    overnightNote: 'This is an overnight shift',
    durationError: 'Shift duration cannot exceed 23:59',
    breakOutsideShiftError: 'Breaks must be within the shift hours',
    footer: {
      create: 'Submit',
      update: 'Save',
    },
  },
  create: {
    success: 'Shift template created successfully',
    error: 'Could not create shift template',
  },
  update: {
    success: 'Shift template updated successfully',
    error: 'Could not update shift template',
  },
};

export default driverShiftsTemplates;
